module.exports = __webpack_public_path__ + "static/media/logo.19aa9c80.png";